const AcceptanceOfSupremacy = require("./AcceptanceOfSupremacy");
const InternationalTourism = require("./InternationalTourism");
const InternationalTradeAgreement = require("./InternationalTradeAgreement");
const LossOfSovereignty = require("./LossOfSovereignty");
const MilitaryAlliance = require("./MilitaryAlliance");
const NavalTradeAgreement = require("./NavalTradeAgreement");
const OpenBordersAgreement = require("./OpenBordersAgreement");
const PeaceTreaty = require("./PeaceTreaty");
const PromiseOfMilitaryProtection = require("./PromiseOfMilitaryProtection");
const ScientificCooperation = require('./ScientificCooperation');
const TradeRoutesAgreement = require("./TradeRoutesAgreement");

module.exports = {
    AcceptanceOfSupremacy,
    InternationalTourism,
    InternationalTradeAgreement,
    LossOfSovereignty,
    MilitaryAlliance,
    NavalTradeAgreement,
    OpenBordersAgreement,
    PeaceTreaty,
    PromiseOfMilitaryProtection,
    ScientificCooperation,
    TradeRoutesAgreement
}